import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface Props {
	children: React.ReactNode;
}

export class ModalPortal extends React.Component<Props> {
	private readonly el: HTMLElement;

	constructor(props: Props) {
		super(props);
		const nodeId = 'modal';
		let node = document.getElementById(nodeId);
		if (node) {
			this.el = node;
			return;
		}

		const body = document.getElementsByTagName('body')[0];
		node = document.createElement('div');
		node.id = nodeId;
		this.el = node;
		body.prepend(node);
	}

	render() {
		return <React.Fragment>{ReactDOM.createPortal(this.props.children, this.el)}</React.Fragment>;
	}
}
